export const STRIDALIZER_MESSAGE_EVENT = 'message';